module.exports = __webpack_public_path__ + "img/dqr.8fe0175e.png";